import { RESPONSE } from '@shared/tokens/server.tokens';
import { Inject, Injectable, Optional } from '@angular/core';
import { UrlTree } from '@angular/router';

@Injectable()
export class SsrResponseManager {
  constructor(@Optional() @Inject(RESPONSE) private _response: any) {
  }

  public setStatus(statusCode: number): void {
    if (this._response) {
      this._response.status(statusCode);
    }
  }

  redirect(url: UrlTree, statusCode: number = 301) {
    if (this._response) {
      this._response.status(statusCode);
      this._response.location(url.toString());
    }
  }
}
